module.exports = __webpack_public_path__ + "static/verdan-7dc269fd6f58014411efeaff1c157c17.jpg";